module.exports = __webpack_public_path__ + "img/malibu-21.9544a1a6.png";